var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.showModal}},[_vm._v(_vm._s(_vm.loading ? 'loading...' : 'expand'))]),(_vm.isModalVisible)?_c('Modal',{attrs:{"quote-hash":_vm.quote_hash},on:{"close":_vm.closeModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }